export default __webpack_public_path__ + "static/slide5-mobile-8cdcc96161c53a730688800a3a5305a4.png";